import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-12 col-md-6 col-lg-4 mb-4" }
const _hoisted_2 = { class: "tablinx-link-item" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "link-item-content link-item-bg p-3" }
const _hoisted_5 = {
  key: 0,
  class: "description d-flex align-items-center mb-2"
}
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = { class: "title mb-2" }
const _hoisted_8 = { class: "description mb-0" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "link-item-content link-item-bg p-3" }
const _hoisted_11 = {
  key: 0,
  class: "description d-flex align-items-center mb-2"
}
const _hoisted_12 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PostCardFooter = _resolveComponent("PostCardFooter")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.post.metaInput)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/post/?id=${_ctx.post._id}`,
            class: "d-block"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.post.metaInput.image,
                alt: "",
                class: "d-block w-100"
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                (_ctx.post.authorContent?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.post.authorContent), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_7, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.post.title), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("small", null, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.post.description), 1)
                  ])
                ]),
                _createVNode(_component_PostCardFooter, {
                  post: _ctx.post,
                  currentUserId: _ctx.currentUserId
                }, null, 8, ["post", "currentUserId"])
              ])
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: `/post/?id=${_ctx.post._id}`,
            class: "d-block"
          }, {
            default: _withCtx(() => [
              (_ctx.post.image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.post.image,
                    alt: "",
                    class: "d-block w-100"
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.post.authorContent?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.post.authorContent), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_PostCardFooter, {
                  post: _ctx.post,
                  currentUserId: _ctx.currentUserId
                }, null, 8, ["post", "currentUserId"])
              ])
            ]),
            _: 1
          }, 8, ["to"]))
    ])
  ]))
}